import { usePublicGalleryVersionURLs, type PublicGalleryScope } from "@/features/gallery/api";
import { AlbumCoverBanner } from "@/features/gallery/components/AlbumCoverBanner";
import type { PublicGalleryAlbum, PublicGalleryAsset } from "@/features/gallery/types";

// Bìa của KHÁCH. Toàn bộ phần trình bày nằm ở AlbumCoverBanner (dùng chung với màn nhân sự);
// file này chỉ lo một việc: tìm ảnh bìa rồi ký đường dẫn ảnh theo token chia sẻ của khách.
//
// Lịch sử để khỏi ai đó "khôi phục" lại bản cũ:
// - Bản 1: bìa DÍNH, co dần thành dải đen cao 176-208px chiếm đỉnh màn mãi mãi. CEO bỏ.
// - Bản 2: bìa phủ TRỌN MÀN, chữ căn giữa. CEO bỏ tiếp — tỉ lệ chạy theo cửa sổ người xem nên
//   cửa sổ vuông thì bìa vuông, mà bìa gump là ảnh NGANG.
// - Bản 3 (nay): dải ngang, tên album IN HOA ở trung tâm, nhãn studio ngay dưới.
//
// Nút "Xem album" đã bỏ cùng bản 3: bìa không còn chiếm hết màn nữa, lưới ảnh nằm ngay bên dưới
// nên khách thấy luôn — thêm một nút chỉ để cuộn xuống đúng chỗ đang nhìn là thừa.

export function AlbumCover({
  scope,
  album,
  fallbackCoverAssetId,
  assets,
}: {
  scope: PublicGalleryScope;
  album: PublicGalleryAlbum;
  fallbackCoverAssetId: string | undefined;
  assets: PublicGalleryAsset[];
}) {
  const cover = assets.find(
    (asset) => asset.assetId === (album.coverAssetId ?? fallbackCoverAssetId),
  );
  const title = album.title || album.name;
  // Danh sách album nay trả sẵn URL đã ký (fix `fab912c8`) — dùng luôn, khỏi hỏi lại máy chủ.
  // Nhánh hỏi-lại nằm ở component RIÊNG bên dưới: hook chỉ được mount khi thật sự cần, chứ
  // không mount rồi tắt bằng `enabled: false` (mount-rồi-tắt vẫn dựng observer thừa).
  const cached = cover?.urls?.large;
  if (cached || !cover) return <AlbumCoverBanner imageUrl={cached} title={title} />;
  return <RemoteAlbumCover scope={scope} cover={cover} title={title} />;
}

function RemoteAlbumCover({
  scope,
  cover,
  title,
}: {
  scope: PublicGalleryScope;
  cover: PublicGalleryAsset;
  title: string;
}) {
  const urls = usePublicGalleryVersionURLs(scope, cover.assetId, cover.version.id, true);
  return <AlbumCoverBanner imageUrl={urls.data?.large} title={title} />;
}
